import React from "react";
import PropTypes from "prop-types";

import Framework from "@beardeddevops/react.framework";
import {Types, Parts} from "components";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Legal_Entities_Object} state
 *  @property {object} model
 *  @property {Legal_Entities_Properties} model.properties
 *  @property {Legal_Entities_Is} model.is
 *  @property {Legal_Entities_Has} model.has
 */
export default class LegalEntity extends ObjectOverride {
	static propTypes = {
		...super.PropTypes,
		updateNameType: PropTypes.func
	};

	constructor(props) {
		super(props, Types.Legal_Entities._name);
		this.state.trust = false;
	}

	/**
	 * @param prevProps
	 * @param {Legal_Entities_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		/** @type {Legal_Entities_Object} object */
		let object = this.state;

		if (typeof this.props.updateNameType === 'function') {
			this.props.updateNameType(object.name, object.trust);
		}
	}

	form = () => {
		/** @type {Legal_Entities_Properties} properties */
		let properties = this.model.properties;
		/** @type {Legal_Entities_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>

						<div className={"col-md"}>
							<h4 className="section-title">{object.trust ? "Trust's" : 'Legal Entity\'s'} Information</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={object.trust ? "Trust's Name" : 'Legal Entity\'s Name'}
									value={object.name}
									error={object.name_error}
									property={properties.name}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<div className={"row"}>
									<div className={"col-md"}>
										<span className="input-label">Type</span>
									</div>
									<div className={"col-md text-right"}>
										<Framework.Elements.ButtonSwitch
											property={properties.trust}
											value={object.trust}
											error={object.trust_error}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={'Trust'}
											labelFalse={'Legal Entity'}
										/>
									</div>
								</div>
							</div>
							<div className={"row"}>
								<div className={"col-md"}>
									<div className="form-group">
										<Framework.Elements.PhoneNumber
											label={"Phone Number"}
											value={object.number}
											error={object.number_error}
											property={properties.number}
											update={this.handleTextFieldPropertyUpdate}
											id={"legal_number"}
										/>
									</div>
								</div>
								<div className={"col-md"}>
									<div className="form-group">
										<Framework.Elements.EmailAddress
											label={"Email Address"}
											value={object.email}
											error={object.email_error}
											property={properties.email}
											update={this.handleTextFieldPropertyUpdate}
											id={"legal_email"}
										/>
									</div>
								</div>
							</div>
						</div>

						<div className={"col-md"}>
							<h4 className="section-title">{object.trust ? 'Primary Trustee\'s Address' : 'Member\'s Address'}</h4>
							<Parts.Address
								object={object}
								properties={properties}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
							/>
						</div>

					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
